module.exports = __webpack_public_path__ + "img/1537715880.e6150d36.jpg";